import firstletter from './dict.js'
import dayjs from 'dayjs'

/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}


export function tips (msg){
	uni.showToast({
		title:msg,
		icon:'none'
	})
}

function formatNumber (n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}

export function formatTime (date) {
  if (isToday(date)) {
    return dayjs(date).format('A HH:mm').replace('PM', '下午').replace('AM', '上午')
  }
  if (isYesterday(date)) {
    return '昨天'
  }
  return getDate(date)
}

export function getDate (date, splitor = '-') {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  // return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(day)}`
  return `${addZeroPrefix(month)}${splitor}${addZeroPrefix(day)}`
}
 
/**
 * 返回时分秒/时分
 * @export
 * @param {*} date
 * @param {boolean} [withSecond=false]
 * @returns
 */
export function getTime (date, withSecond = false) {
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return withSecond ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}` : `${hour}:${addZeroPrefix(minute)}`
}

export function getFullDate (date) {
  return `${getDate(date)} ${getTime(date)}`
}

export function isToday (date) {
  return date.toDateString() === new Date().toDateString()
}

export function isYesterday (date) {
	let newDate = new Date(date).getTime()
	newDate += 1000*60*60*24
	return new Date(newDate).toDateString() === new Date().toDateString()
}

/**
 * 个位数，加0前缀
 * @param {*} number
 * @returns
 */
function addZeroPrefix (number) {
  return number < 10 ? `0${number}` : number
}

export function throttle (func, wait) {
  let timeout
  return function () {
    let that = this
    let args = arguments

    if (!timeout) {
      timeout = setTimeout(function () {
        timeout = null
        func.apply(that, args)
      }, wait)
    }
  }
}
export function formatDuration (time) {
  let interval = time
  let continued = ''
  if (interval > 3600) {
    const hour = Math.floor(interval / 3600)
    continued += hour + '小时'
    interval -= hour * 3600
  }
  if (interval > 60 && interval < 3600) {
    const min = Math.floor(interval / 60)
    continued += min + '分'
    interval -= min * 60
  }
  if (interval < 60) {
    continued += Math.floor(interval) + '秒'
  }
  return continued
}

// 获取中文字符首字母拼音
export function pinyin (raw) {
  const str = `${raw}`
  if (!str || /^ +$/g.test(str)) {
    return ''
  }
  let result = []
  for (let i = 0; i < str.length; i++) {
    let unicode = str.charCodeAt(i)
    let char = str.charAt(i)
    if (unicode >= 19968 && unicode <= 40869) {
      char = firstletter.charAt(unicode - 19968)
    }
    result.push(char)
  }
  return result.join('')
}
// 判断是否是json string
export function isJSON (str) {
  if (typeof str === 'string') {
    try {
      let obj = JSON.parse(str)
      return !!(typeof obj === 'object' && obj)
    } catch (e) {
      return false
    }
  }
}

// 将query对象转化为string
export function queryString (query) {
  let qr = ''
  for (let key in query) {
    if (query[key]) {
      qr += `&${key}=${encodeURIComponent(query[key])}`
    }
  }
  return qr.slice(1)
}

// 查询用户头像，返回Object{userID: avatar}
export async function getUserProfile (userIDList) {
  const avatarList = {}
  const res = await wx.$app.getUserProfile({ userIDList })
  if (res.code === 0) {
    const data = res.data || []
    for (let i = 0; i < data.length; i++) {
      avatarList[data[i].userID] = data[i].avatar || ''
    }
  }
  return avatarList
}

export default {
  formatNumber,
  formatTime,
  throttle,
  formatDuration,
  pinyin,
  isJSON
}
